import './UserInfo.scss';
import { useAppContext } from '../../context/AppContext';

// The user's photo (or initials), optionally with their name.
// `showName={false}`: just the round photo, e.g. the header's profile button.
const UserInfo = ({ onClick, showName = true }: { onClick?: () => void; showName?: boolean }) => {
  const { user } = useAppContext();

  const initials = user?.name
    ? user.name.split(' ').map((n: string) => n[0]).join('').toUpperCase().slice(0, 2)
    : user?.email?.[0]?.toUpperCase() || '?';

  return (
    <div className="userinfo" onClick={onClick}>
      {user?.image ? (
        <img className="userinfo__image" src={user?.image} alt="" />
      ) : (
        <div className="userinfo__image userinfo__image--default">
          {initials}
        </div>
      )}

      {showName && (
        <p className="userinfo__name">
          {user?.name || user?.email?.split('@')[0]}
        </p>
      )}
    </div>
  );
};

export default UserInfo;